import { IconInformationOutline } from '@icons/IconInformationOutline'
import { MarkdownDocumentationHover } from '../MdTextComponent/MarkdownDocumentationHover'

export function ListCardHoverMetadataIcon({ hoverMetadata }: { hoverMetadata: string | undefined }) {
  if (!hoverMetadata) return null

  return (
    <MarkdownDocumentationHover documentation={hoverMetadata}>
      <button
        type="button"
        className="inline-flex shrink-0 border-0 bg-transparent p-0"
        onClick={(event) => event.stopPropagation()}
      >
        <IconInformationOutline className="size-3.5 text-foreground/70" />
      </button>
    </MarkdownDocumentationHover>
  )
}
